// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"296":"component---src-pages-404-tsx","348":"component---src-pages-index-tsx","944":"3cc8a872"}[chunkId] + "-" + {"296":"29e41f9ecda3782241c0","348":"6d9edbb86c45cf471040","944":"c7b8f25559b01958ced1"}[chunkId] + ".js";
};